// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_COUNSELING_REPORT_LOADING = 'ADD_COUNSELING_REPORT_LOADING';
export const ADD_COUNSELING_REPORT_SUCCESS = 'ADD_COUNSELING_REPORT_SUCCESS';
export const ADD_COUNSELING_REPORT_ERROR = 'ADD_COUNSELING_REPORT_ERROR';
export const UPDATE_COUNSELING_REPORT_LOADING = 'UPDATE_COUNSELING_REPORT_LOADING';
export const UPDATE_COUNSELING_REPORT_SUCCESS = 'UPDATE_COUNSELING_REPORT_SUCCESS';
export const UPDATE_COUNSELING_REPORT_ERROR = 'UPDATE_COUNSELING_REPORT_ERROR';
export const DELETE_COUNSELING_REPORT_LOADING = 'DELETE_COUNSELING_REPORT_LOADING';
export const DELETE_COUNSELING_REPORT_SUCCESS = 'DELETE_COUNSELING_REPORT_SUCCESS';
export const DELETE_COUNSELING_REPORT_ERROR = 'DELETE_COUNSELING_REPORT_ERROR';

export function addReport(patientId: string, report: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/counselingReport/addCounselingReport`,
      {
        ...report,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_COUNSELING_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_COUNSELING_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_COUNSELING_REPORT_LOADING,
    });
  });
}

export function updateReport(patientId: string, report: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/counselingReport/updateCounselingReport`,
      {
        ...report,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_COUNSELING_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_COUNSELING_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_COUNSELING_REPORT_LOADING,
    });
  });
}

export function deleteReport(patientId: string, reportId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/counselingReport/deleteCounselingReport`,
      {
        reportId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_COUNSELING_REPORT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_COUNSELING_REPORT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_COUNSELING_REPORT_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/counselingReportActions.js